import * as React from "react";
import i18next from "i18next";
import classNames from "classnames";
import { useCallback, useEffect, useState } from "react";
import { useAppContext } from "../../Contexts/AppContext";
import { useMapDownloadContext } from "../../Contexts/MapDownloadContext";
import { Feature } from "ol";
import { Fill, Stroke, Style } from "ol/style";

const highLightStyle = new Style({
    fill: new Fill({
        color: [255, 255, 0, 0.3]
    }),
    stroke: new Stroke({
        color: [255, 255, 0],
        width: 3
    })
});

export const SelectedSheets = (): JSX.Element => {
    const { setHighlightFeatures, setLocateFeature } = useAppContext();
    const { sheetFeatures, setSheetFeatures } = useMapDownloadContext();
    const { setLimitExceeded } = useMapDownloadContext();
    const [activeItem, setActiveItem] = useState<Feature>(null);

    useEffect(() => {
        sheetFeatures && setHighlightFeatures(sheetFeatures);
        !sheetFeatures?.length && setActiveItem(null);
    }, [sheetFeatures]);

    useEffect(() => {
        sheetFeatures &&
            sheetFeatures.map((f) =>
                activeItem && f.get("OBJECTID") === activeItem.get("OBJECTID")
                    ? f.setStyle(highLightStyle)
                    : f.setStyle()
            );
    }, [activeItem]);

    const onRemove = useCallback(
        (feature) => {
            setSheetFeatures(sheetFeatures.filter((f) => f.get("OBJECTID") !== feature.get("OBJECTID")));
        },
        [sheetFeatures]
    );

    const onRemoveAll = () => {
        setSheetFeatures([]);
        setActiveItem(null);
        setLimitExceeded(false);
        setHighlightFeatures([]);
    };

    const onHighlight = (feature: Feature) => setActiveItem(feature);

    const onZoom = (feature: Feature) => setLocateFeature(feature);

    return (
        <div className="selected-list">
            <div className="selected-list-label">{i18next.t("mapDownload.downloadList")}</div>
            <div className="scrollable-content-container">
                <div className="scrollable-content">
                    {sheetFeatures?.length
                        ? sheetFeatures.map((f, index) => (
                              <div
                                  className={classNames("selected-list-item", {
                                      active: activeItem && f.get("OBJECTID") === activeItem.get("OBJECTID")
                                  })}
                                  key={index}
                              >
                                  <span title={i18next.t("mapDownload.highlightMap")} onClick={() => onHighlight(f)}>
                                      {f.get("Karšu lapas numurs")}
                                  </span>
                                  <span
                                      className="selected-list-item-button"
                                      title={i18next.t("mapDownload.removeMap")}
                                      onClick={() => onZoom(f)}
                                  >
                                      <span className="icon-geolite-zoom"></span>
                                  </span>
                                  <span
                                      className="selected-list-item-button"
                                      title={i18next.t("mapDownload.removeMap")}
                                      onClick={() => onRemove(f)}
                                  >
                                      <span className="icon-geolite-trash"></span>
                                  </span>
                              </div>
                          ))
                        : null}
                </div>
                {sheetFeatures?.length >= 2 && (
                    <div className="selected-list-item remove-all">
                        {i18next.t("mapDownload.removeAll")}
                        <span
                            className="selected-list-item-button"
                            title={i18next.t("mapDownload.removeMap")}
                            onClick={onRemoveAll}
                        >
                            <span className="icon-geolite-trash"></span>
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};
